<template>
    <div class="panel-wrapper">
        <div class="panel-wrapper__title">
            <div>租金预算：</div>
            <div style="color: #56a3a6" @click="clear">清除</div>
        </div>

        <div class="scroll-container">
            <div class="form-item">
                <div class="form-item__body filter-radio">
                    <div :class="['form-item__body_input wrapper radio filter-radio__item', item.selected ? 'active' : '']"
                    v-for="(item, index) in prices" :key="index" @click="select(index)">
                        <div class="form-item__body_input_text">{{item.name}}</div>
                        <img mode="aspectFit"
                        class="form-item__body_icon"
                        src="@/assets/icons/circle-check-sharp-solid.svg"
                        :style="{opacity: item.selected ? 1 : 0}"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="panel-wrapper__footer">
            <div class="panel-wrapper__footer_btn" @click="search">
                确 定
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['filters'],
        data () {
            return {
                prices: [
                    {name: '1k以下', min: 0, max: 1000, selected: false},
                    {name: '1k~2k', min: 1000, max: 2000, selected: false},
                    {name: '2k~4k', min: 2000, max: 4000, selected: false},
                    {name: '4k~6k', min: 4000, max: 6000, selected: false},
                    {name: '6k~8k', min: 6000, max: 8000, selected: false},
                    {name: '8k~10k', min: 8000, max: 10000, selected: false},
                    {name: '10k~15k', min: 10000, max: 15000, selected: false},
                    {name: '15k以上', min: 15000, max: 0, selected: false}
                ]
            }
        },
        methods: {
            select (index) {
                this.prices[index].selected = !this.prices[index].selected
            },
            clear () {
                for (let i = 0; i<this.prices.length; i++) {
                    this.prices[i].selected = false
                }
            },
            search () {
                const costs = []
                for (let i = 0; i<this.prices.length; i++) {
                    const price = this.prices[i]
                    if (price.selected) {
                        costs.push(`${price.min},${price.max}`)
                    }
                }
                this.$emit('search', {
                    cost: costs.join(';')
                })
            }
        }
    }
</script>
